module.exports = __webpack_public_path__ + "static/img/list-bg-5.140c287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/list-bg-5.png
// module id = 65T2
// module chunks = 1